export const featureList = [
  {
    description:
      'We’ll help import your catalog from wherever it’s currently stored, for no additional charge.',
  },
  {},
  {
    description:
      'Edit your metadata via spreadsheet and we’ll re-import it for you.',
  },
  {},
  {
    description:
      'Automatically creates an AIFF copy of your WAV files, and a WAV copy of your AIFF files.',
  },
  {
    description: 'Ingest back catalog and new releases from your distributor.',
  },
  {
    description:
      'Pages are customizable playlist templates for showcasing releases and artists.',
  },
  {},
  {
    description: 'Receive files from anyone with DISCO inboxes.',
  },
  {
    description:
      'Themes allow you to customize your playlist presentation background and logo.',
  },
  {
    description:
      'Alias metadata lets you control what metadata on your tracks gets shared.',
  },
  {
    description:
      'Assigned URLs let you generate a trackable link for playlists that you can share by your own means.',
  },
  {
    description:
      'Control what audio formats are available on playlists you share.',
  },
  {
    description:
      ' The Email Creator lets you easily send great looking email newsletters to lists of any size, like you would on Mailchimp, Campaign Monitor or Constant Contact.',
  },
  {
    description:
      'The kill share function lets you revoke access to a share URL you’ve generated',
  },
  {
    description:
      'Custom inboxes let you create special inboxes for projects or different types of deliveries.',
  },
  {},
  {},
  {
    description:
      'Shareable channels let you share larger amounts of music, including whole catalogs.',
  },
  {},
  {},
  {
    description: 'Extend what metadata you can store with custom fields.',
  },
  {
    description:
      'Territory restrictions let you restrict the availability of files within your team based on the tracks’ assigned territories.',
  },
  {},
  {},
  {
    description: 'Track page opens, playlist and track downloads, and streams.',
  },
  {
    description:
      'Track which tracks were streamed and downloaded, and how many times.',
  },
  {
    description:
      'DISCO’s Insights dashboard gives you powerful insights on how your music and files are being used – both by your team and the people you send music to.',
  },
  {
    description:
      'DISCO’s reporting function lets you quickly generate powerful insights on you and your team’s activity in the app. Generate pitch reports, export metadata and more.',
  },
  {},
  {},
  {},
  {},
]
